import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { PayinPaymentSwitchingRequest, PayinPaymentSwitchingResponse } from '../entities';

@Injectable({ providedIn: 'root' })
export class PayinPayoutSwitchingDataService {
    private readonly http = inject(HttpClient);

    private readonly url = '/rest/account-settings/payment-direction-activity-settings';

    getPaymentDirectionActivitySettings(): Observable<PayinPaymentSwitchingResponse> {
        return this.http.get<PayinPaymentSwitchingResponse>(`${environment.apiUrl}${this.url}`);
    }

    changePaymentDirectionActivitySettings(data: PayinPaymentSwitchingRequest): Observable<void> {
        return this.http.post<void>(`${environment.apiUrl}${this.url}`, data);
    }
}
